// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

mat-dialog-content {
  min-width: 760px;
  min-height: 200px;
  padding: 2px 24px !important;
  background-color: #f0f0f0;
}

.content {
  padding: 16px;
  border-radius: 4px;
}

.form-row {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 16px;
}

.field-label {
  flex: 0 0 140px;
  padding-top: 6px;
  font-size: 0.85rem;
  color: #000;
}

.form-control {
  flex: 1;
  min-height: 100px;
  resize: vertical;
  color: #000;
}

.old-note {
  min-height: 90px;
  max-height: 200px;
  background: #DBDCDD;
  resize: none;
  overflow-y: auto;
  white-space: pre-wrap;
  font-family: "GothamNarrowBook";
  font-size: 13px;
  line-height: 1.4;
}

mat-dialog-actions {
  background-color: #f0f0f0;
  padding: 8px 24px !important;
}

.button-gap {
  gap: 12px;
}

.error-text {
  color: #E21836;
  margin-left: 156px;
  margin-top: 4px;
}

`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/append-note-dialog/append-note-dialog.component.css"],"names":[],"mappings":";;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":["\n\nmat-dialog-content {\n  min-width: 760px;\n  min-height: 200px;\n  padding: 2px 24px !important;\n  background-color: #f0f0f0;\n}\n\n.content {\n  padding: 16px;\n  border-radius: 4px;\n}\n\n.form-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.field-label {\n  flex: 0 0 140px;\n  padding-top: 6px;\n  font-size: 0.85rem;\n  color: #000;\n}\n\n.form-control {\n  flex: 1;\n  min-height: 100px;\n  resize: vertical;\n  color: #000;\n}\n\n.old-note {\n  min-height: 90px;\n  max-height: 200px;\n  background: #DBDCDD;\n  resize: none;\n  overflow-y: auto;\n  white-space: pre-wrap;\n  font-family: \"GothamNarrowBook\";\n  font-size: 13px;\n  line-height: 1.4;\n}\n\nmat-dialog-actions {\n  background-color: #f0f0f0;\n  padding: 8px 24px !important;\n}\n\n.button-gap {\n  gap: 12px;\n}\n\n.error-text {\n  color: #E21836;\n  margin-left: 156px;\n  margin-top: 4px;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
